
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import { getLevelOptions } from "../../template/common";
@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifCompose: any;
  @Prop()
  private detail: any;
  @Watch("detail", { immediate: true })
  private detailChange() {
    // 处理数据
    this.data = JSON.parse(JSON.stringify(this.detail));
    if (!this.data.report["面象信息"]) {
      this.data.report["面象信息"] = {
        面色: [],
        唇态: ["润"],
        唇色: [],
        鼻光泽: ["有光泽"],
        鼻形态: ["正常"],
        鼻颜色: ["正常肤"],
        人中形态: ["短浅"],
        人中颜色: ["正常肤色"],
      };
      // 转格式,填充数据
      const oldData: any = this.data.report["面象信息输出"];
      // 面色
      if (oldData[0]) {
        const text: any = oldData[0];
        this.data.report["面象信息"]["面色"].push(text);
      }
      if (oldData[1] && oldData[1] == "有") {
        this.data.report["面象信息"]["面色"].push("两颧红");
      }
      if (oldData[2] && oldData[2] == "有") {
        this.data.report["面象信息"]["面色"].push("眼眶黑");
      }
      if (oldData[3]) {
        const text: any = oldData[3];
        this.data.report["面象信息"]["面色"].push(text);
      }
      // 唇色
      if (oldData[4]) {
        const text: any = oldData[4];
        this.data.report["面象信息"]["唇色"].push(text);
      }
      this.$forceUpdate();
    }
  }
  private data: any = {};
  private colors: any = [
    "#08C664",
    "#ECA12C",
    "#F60D0D",
    "#F541F3",
    "#19DDDB",
    "#94E51A",
    "#0CCDA9",
    "#DFD111",
    "#A911DF",
    "#6D65EE",
  ];
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  /**
   * @param val <string array>
   */
  private getShowContent(val: any) {
    let result: any = "";
    if (val && val.length > 0) {
      result = val.join("、");
    }
    return result;
  }
  private editorChange(e: any) {
    this.data.report.suggest = e;
    this.change();
  }
  private change() {
    this.$emit("changeData", this.data);
  }
  // 舌色和苔色改变
  private change2(e: any, type: any) {
    if (type == "面色") {
      this.data.report["面色唇色参数"][3][0] = e;
      this.$forceUpdate();
    } else if (type == "唇色") {
      this.data.report["面色唇色参数"][3][6] = e;
      this.$forceUpdate();
    }
    this.change();
  }
  private getLevelOptions(type: any, key: any, level: any) {
    return getLevelOptions(type, key, level);
  }
  private open(url: any) {
    window.open(url);
  }
  private mounted() { }
}
